import React from 'react';
import { useLocation } from 'react-router-dom';
import { Calculator, Phone, MessageCircle } from 'lucide-react';
import { isTrackedPath } from '../lib/analytics';

// Sticky bottom bar on phones for public pages: quote, call, WhatsApp.
export const MobileActions = () => {
  const { pathname } = useLocation();
  if (!isTrackedPath(pathname)) return null;
  const item = 'flex-1 h-14 flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold';
  return (
    <>
      <div className="h-14 sm:hidden" aria-hidden="true" />
      <nav aria-label="Quick actions" data-cta-area="mobile-sticky" className="sm:hidden fixed inset-x-0 bottom-0 z-50 flex bg-white border-t border-slate-200 shadow-[0_-6px_20px_-10px_rgba(11,37,69,0.35)]" data-testid="mobile-actions">
        <a href="/#quote" className={`${item} bg-[color:var(--mv-orange)] text-white`} data-testid="mobile-actions-quote"><Calculator className="w-5 h-5" />Get a quote</a>
        <a href="tel:07985291097" className={`${item} text-[color:var(--mv-navy)]`} data-testid="mobile-actions-call"><Phone className="w-5 h-5" />Call</a>
        <a href="https://wa.me/447985291097" target="_blank" rel="noreferrer" className={`${item} text-[#128C4A]`} data-testid="mobile-actions-whatsapp"><MessageCircle className="w-5 h-5" />WhatsApp</a>
      </nav>
    </>
  );
};
